import {textSizes} from '@stencil/build-theme';
import styled from 'styled-components';

export const RefundTimelineBarWrapper = styled.div`
  .rfnd {
    min-height: 60px;
  }
  .rfnd__topBarCont {
    position: relative;
  }
  .rfnd__topBar {
    display: flex;
    height: 22px;
    border-radius: 22px;
  }
  .rfnd__topBar--col {
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    position: relative;
    flex: 1;
  }
  .rfnd__topBar--col::after {
    height: 22px;
    border: 1px #000000 dashed;
    position: absolute;
    right: 0;
    top: 0;
    content: '';
  }
  .rfnd__topBar--col::before {
    height: 10px;
    width: 2px;
    background-color: #000000;
    position: absolute;
    right: 0;
    bottom: -10px;
    content: '';
  }
  .rfnd__topBar--col:last-child:after {
    display: none;
  }
  .rfnd__topBar--col:last-child:before {
    display: none;
  }
  .rfnd__topBar--col.green {
    background-color: #249995;
  }
  .lightYellowText {
    color: #cd9100;
    ${textSizes.SmallW3};
  }
  .rfnd__topBar--colText {
    font-size: 11px;
    line-height: 22px;
  }
  .rfnd__topBar--col:first-child {
    padding: 0 8px 0 28px;
    border-radius: 22px 0 0 22px;
  }
  .rfnd__topBar--col:last-child {
    width: 120px;
    padding: 0 28px 0 12px;
    text-align: right;
    flex-shrink: 0;
    border-radius: 0 22px 22px 0;
    flex: none;
  }
  .rfnd__topBar--col:only-child {
    width: 100%;
    border-radius: 22px;
  }
  .rfnd__topBar--col.yellow {
    background-color: #ffefc6;
    color: #cd9100;
  }
  .rfnd__topBar--oval {
    display: inline-flex;
    width: 14px;
    height: 14px;
    box-shadow: inset 0 1px 3px 0 rgb(0 0 0 / 50%);
    background-color: #ffffff;
    border-radius: 16px;
    flex-shrink: 0;
    position: absolute;
    top: 4px;
    z-index: 1;
  }
  .rfnd__topBar--ovalLeft {
    left: 5px;
  }
  .rfnd__topBar--ovalRight {
    right: 5px;
  }
  .rfnd__bottomText {
    position: absolute;
    top: 32px;
    width: 100%;
    text-align: right;
    display: flex;
    flex-direction: column;
    right: 0;
  }
  .rfnd__bottomText--title {
    ${textSizes.SmallW2};
    color: #333333;
    align-self: flex-end;
    position: relative;
    right: -32px;
  }
  .rfnd__bottomText--subTitle {
    ${textSizes.SmallW1};
    color: #979797;
    align-self: flex-end;
    right: -14%;
  }
  .rfnd__topBar--col:last-child .rfnd__bottomText--title {
    right: unset;
  }
  .rfnd__topBar--col:last-child .rfnd__bottomText--subTitle {
    right: unset;
  }
  .rfnd__bottomText--now {
    ${textSizes.SmallW2};
    color: #333333;
    position: absolute;
    left: 0;
    top: 32px;
  }
  .whiteText {
    color: white;
    ${textSizes.SmallW3};
  }
  // html[lang="ara"] .rfnd__topBar--col:last-child {
  //   border-radius: 22px 0 0 22px;
  // }
  // html[lang="ara"] .rfnd__topBar--col:nth-child(1) {
  //   border-radius: 0 22px 22px 0;
  // }
  // html[lang="ara"] .rfnd__bottomBar--col:first-child {
  //   text-align: right;
  //   width: 45.6%;
  //   flex: unset;
  // }
  // html[lang="ara"] .rfnd__bottomBar--col:last-child {
  //   text-align: left;
  // }
  // html[lang="ara"] .rfnd__topBar--col::before {
  //   left: 0;
  //   right: unset;
  // }
  // html[lang="ara"] .rfnd__topBar--col::after {
  //   left: 0;
  //   right: unset;
  // }
`;
